/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Payout_State_Needs_ApprovalInputs */



/**
* | output |
* | --- |
* | "Needs approval" |
*
* @param {Partner_Payout_State_Needs_ApprovalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_payout_state_needs_approval = /** @type {((inputs?: Partner_Payout_State_Needs_ApprovalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Payout_State_Needs_ApprovalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Freigabe nötig")
	return /** @type {LocalizedString} */ ("Needs approval")
});